import { Box, Flex } from '@chakra-ui/react';

import { Iteration } from 'Component/others';
import { TextSemiBold } from 'UiKit/typography';

import styles from './styles.module.css';

const tabClassNames = {
  block: {
    container: styles['form-switch-tab__container'],
    active: styles['form-switch__tab--active'],
    inactive: styles['form-switch__tab--inactive'],
    activeText: styles['form-switch__tab--active-text'],
    inactiveText: styles['form-switch__tab--inactive-text'],
  },
  line: {
    container: styles['form-switch-tab__container--line'],
    active: styles['form-switch__tab--line-active'],
    inactive: styles['form-switch__tab--line-inactive'],
    activeText: styles['form-switch__tab--line-active-text'],
    inactiveText: styles['form-switch__tab--line-inactive-text'],
  },
};

function getTabClassNames(variant, isActive) {
  const v = tabClassNames[variant] || tabClassNames.block;
  return {
    container: v.container,
    tab: isActive ? v.active : v.inactive,
    text: isActive ? v.activeText : v.inactiveText,
  };
}

const SwitchTab = ({ options, value, handleChange, variant = 'block', className }) => {
  const { container } = getTabClassNames(variant, false);

  return (
    <Box className={`${container} ${className}`}>
      <Flex alignItems={'center'} gap={'10px'}>
        <Iteration
          items={options}
          render={(opt) => {
            const isActive = opt?.type === value;
            const { tab, text } = getTabClassNames(variant, isActive);
            
            return (
              <Box
                key={opt?.type}
                className={tab}
                onClick={() => handleChange(opt.type)}
              >
                <TextSemiBold className={text}>{opt.label}</TextSemiBold>
              </Box>
            );
          }}
        />
      </Flex>
    </Box>
  );
};

export default SwitchTab;
